import React from 'react'
import { UserEditFormSupplierStyle } from './styled'
import {
  Button,
  Image,
  Input,
  Section,
  SelectBox,
  Switcher,
} from '../../components'
import { ICONS } from '../../themes'
import { ROUTE_PATH, redirect, STRING } from '../../helpers'
import { EMAIL_REGEX } from 'helpers'
import { toast } from 'react-toastify'
import { store } from 'store'
import { usermanageController } from '../../apiService'
import { toastFail } from '../../helpers/functions/toastFail'

export class UserEditFormSupplierContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      optionsRole: [{ value: 5, label: 'Admin' }],
      isActive: true,
      optionsRoleValue: null,
      isEditPageState: false,
      status: '',
      email: '',
      full_name: '',
      Phone: '',
      nameValid: true,
      emailValid: true,
      phoneValid: false,
      roleValid: false,
      role: '',
      lockSave: false,
      formValid: true,
      id: '',
      toastActive: false,
      submitted: true,
    }
  }
  componentDidMount() {
    let url = window.location.pathname
    let id = url.substring(url.lastIndexOf(':') + 1)
    this.setState({ id: id })
    this._fetchgetSupplierID(id)
  }

  _fetchgetSupplierID(id) {
    this.setState({ isLoading: true })
    return usermanageController()
      .getSuppliernById(id)
      .then(res => this.mapState(res))
      .finally(() => this.setState({ isLoading: false }))
  }

  toastActive = e => {
    toast(e, {
      position: 'top-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      type: 'success',
    })
  }

  toastFill = e => {
    toast(e, {
      position: 'top-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      type: 'error',
    })
  }

  mapState = res => {
    this.setState({
      full_name: res.full_name,
      email: res.email,
      Phone: res.phone,
      role: parseInt(res.role),
      isActive: res.status === 1 ? true : false,
    })
  }

  handleUserInput = e => {
    const { name, value } = e.target

    if (name === 'email') this.setState({ lockSave: true })
    this.setState({ [name]: value }, () => {
      this.validateField(name, value.trim())
    })
  }

  handleUserDropdown = optionsRole => {
    this.setState({ role: optionsRole.value }, () => {
      this.validateField(optionsRole.label, optionsRole.value)
      // console.log('value', optionsRole.value)
    })
  }

  handleChange = e => {
    this.setState(prevState => ({
      isActive: !prevState.isActive,
    }))
  }

  validateField = (fieldName, value) => {
    // console.log('xxxx ', fieldName, '  sss ', value)

    let nameValid = this.state.full_name
    let emailValid = this.state.email
    let phoneValid = this.state.phoneValid

    switch (fieldName) {
      case 'full_name':
        nameValid = value.length !== 0
        this.setState({ nameValid: nameValid })
        break
      case 'email':
        emailValid = RegExp(EMAIL_REGEX).test(value)
        //console.log('emailValid', emailValid)
        this.setState({ emailValid: emailValid })
        break
      case 'Phone':
        phoneValid = value.length !== 0
        this.setState({ phoneValid: phoneValid })
        break
      default:
        break
    }
  }

  checkSelect = v => {
    const value = this.state.optionsRole.find(e => e.value == 1)

    // console.log(value)
    if (value !== undefined) {
      return value
    }
    return false
  }
  checkSelect1 = v => {
    const value = this.state.optionsRole.find(e => e.value == 2)

    // console.log(value)
    if (value !== undefined) {
      return value
    }
    return false
  }

  onFormSubmit = () => {
    let data = {
      id: parseInt(this.state.id),
      email: this.state.email,
      full_name: this.state.full_name,
      Phone: this.state.Phone,
      role: parseInt(this.state.role),
      status: this.state.isActive ? 1 : 2,
    }

    // e.preventDefault()
    if (
      this.state.nameValid &&
      this.state.emailValid &&
      this.state.Phone !== ''
    ) {
      this.setState(
        {
          formValid: true,
        }
        // () =>
        //   usermanageController()
        //     .updateUserSupplier(data)
        //     .then(res => {
        //       setTimeout(() => {
        //         this.toastActive(res.message)
        //         this.props.history.push(
        //           ROUTE_PATH.USER_MANAGEMENT_SUPPLIER.LINK
        //         )
        //       }, 500)
        //     })
        //     .finally(() =>
        //       this.setState(
        //         { isLoading: false },
        //         this.props.history.push(
        //           ROUTE_PATH.USER_MANAGEMENT_SUPPLIER.LINK
        //         )
        //       )
        //     )
      )
    }
  }

  onFormSubmitEmail = e => {
    let data = {
      id: parseInt(this.state.id),
      email: this.state.email,
      full_name: this.state.full_name,
      Phone: this.state.Phone,
      role: parseInt(this.state.role),
      status: this.state.isActive ? 1 : 2,
    }

    e.preventDefault()
    if (this.state.nameValid && this.state.emailValid) {
      this.setState(
        {
          submitted: false,
          formValid: true,
        },
        () =>
          usermanageController()
            .updateEmailSupplier(data)
            .then(res => {
              if (res) {
                if (res.status === 'EmailDuplicate') {
                  this.setState({
                    submitted: true,
                  })
                  toast('Email duplicate please change email', {
                    position: 'top-center',
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    type: 'error',
                  })
                } else if (res.status === 'SendMailSuccess') {
                  this.setState({
                    submitted: true,
                  })
                  this.toastActive('Resend Activation Email')
                }
              }
            })
            .finally(
              () =>
                // this.props.history.push(ROUTE_PATH.USER_MANAGEMENT_BUYER.LINK)
                this.setState({ lockSave: false })
              //setTimeout(() => this._fetchgetUser(), 500)
            )
      )
    } else {
      this.setState({
        formValid: false,
      })
    }
  }

  render() {
    const { optionsRole, isActive } = this.state

    return (
      <UserEditFormSupplierStyle>
        {/* PAGE TITLE
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_user_form"
                src={ICONS['icon-user-white.svg']}
                alt="page icon"
              />
            </Section>

            <Section className="title-and-breadcrumb">
              <Section id="page_title_user_form" className="title">
                User Management
              </Section>

              <Section id="page_breadcrumb_user_form" className="breadcrumbs">
                <Button
                  className="breadcrumb"
                  onClick={() => {
                    this.props.history.push(ROUTE_PATH.HOME.LINK)
                  }}
                >
                  <span>{STRING.HOME}</span>
                </Button>

                <Button
                  onClick={() => {
                    this.props.history.push(
                      ROUTE_PATH.USER_MANAGEMENT_SUPPLIER.LINK
                    )
                  }}
                  className="breadcrumb"
                >
                  <span>User Management</span>
                </Button>

                <Button className="breadcrumb current">
                  <span>Edit User</span>
                </Button>
              </Section>
            </Section>
          </Section>
        </Section>

        {/* PAGE CONTENT
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="main-content form">
          <Section className="content-body">
            <Section className="form-wrapper">
              <Section className="form-group-title">Edit User</Section>

              <Section
                className={
                  'form-group' +
                  (this.state.full_name === '' ? ' is-error' : '')
                }
              >
                <label>Full Name</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      id="fullname"
                      className={this.state.full_name === '' ? ' is-error' : ''}
                      type="text"
                      name="full_name"
                      value={this.state.full_name.trim()}
                      onChange={this.handleUserInput}
                    />
                  </Section>

                  <Section className="message">
                    {this.state.full_name === '' ? STRING.INVALID : ''}
                  </Section>
                </Section>
              </Section>

              <Section
                className={
                  'form-group' +
                  (this.state.emailValid
                    ? ''
                    : this.state.formValid
                    ? ''
                    : ' is-error')
                }
              >
                <label>Email</label>

                <Section className="form-group-control with-button">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      id="email"
                      className={
                        this.state.emailValid
                          ? ''
                          : this.state.formValid
                          ? ''
                          : 'is-error'
                      }
                      type="text"
                      name="email"
                      value={this.state.email}
                      onChange={this.handleUserInput}
                    />

                    <Button
                      className="theme-blue resend-activation-email"
                      disabled={this.state.lockSave === false ? true : false}
                      onClick={
                        this.state.lockSave !== false
                          ? this.onFormSubmitEmail
                          : null
                      }
                    >
                      {this.state.submitted ? (
                        'Resend Activation Email'
                      ) : (
                        <span className="loader"></span>
                      )}
                    </Button>
                  </Section>

                  {this.state.email === '' && (
                    <Section className="message">{STRING.INVALID}</Section>
                  )}
                  {!this.state.emailValid && this.state.email !== '' && (
                    <Section className="message">
                      {STRING.EMAIL_INVALID}
                    </Section>
                  )}

                  {this.state.emailValid && this.state.email !== '' && (
                    <Section className="message">{''}</Section>
                  )}
                </Section>
              </Section>

              <Section
                className={
                  'form-group' + (this.state.Phone === '' ? ' is-error' : '')
                }
              >
                <label>Phone</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      id="Phone"
                      className={
                        'form-group' +
                        (!this.state.phoneValid
                          ? ''
                          : this.state.formValid
                          ? ''
                          : ' is-error')
                      }
                      type="text"
                      name="Phone"
                      value={this.state.Phone.trim()}
                      onChange={this.handleUserInput}
                    />
                  </Section>

                  <Section className="message">
                    {this.state.Phone === '' ? STRING.INVALID : ''}
                  </Section>
                </Section>
              </Section>

              <Section className="form-group">
                <label>Role</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <SelectBox
                      id="active_status_filter"
                      options={optionsRole}
                      onChange={this.handleUserDropdown}
                      value={this.state.optionsRole.find(
                        e => e.value == this.state.role
                      )}
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>

              <Section className="form-group">
                <label>Active</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Switcher
                      onChange={() => this.handleChange(isActive)}
                      checked={isActive}
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-actions">
              <Button
                className="theme-border-gray"
                onClick={() => {
                  this.props.history.push(
                    ROUTE_PATH.USER_MANAGEMENT_SUPPLIER.LINK
                  )
                }}
              >
                Cancel
              </Button>

              <Button
                className="theme-green"
                onClick={() => {
                  this.state.lockSave !== true
                    ? this.onFormSubmit()
                    : toastFail('Please Resend Activation Email')
                }}
                disabled={this.state.lockSave}
              >
                Save
              </Button>
            </Section>
          </Section>
        </Section>
      </UserEditFormSupplierStyle>
    )
  }
}
